import React, { useState } from 'react';
import axios from 'axios';
import { Form, Button, Alert, Container, Row, Col } from 'react-bootstrap';
import api from '../redux/actions/configApi';
import menuLogo from "../assets/imagens/pentalobe.png";
import { useLocation, useNavigate } from 'react-router-dom';

const ResetPassword = () => {
    const location = useLocation();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const getQueryParams = (search) => {
        return new URLSearchParams(search);
    };
    const queryParams = getQueryParams(location.search);
    const token = queryParams.get("token");
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(''); // Limpa mensagens de erro
        setMessage(''); // Limpa mensagens de sucesso

        try {
            const response = await api.post(`reset-password/${token}`, { password, password_confirmation: confirmPassword });
            setMessage(response.data.message);
        } catch (error) {
            // Exibe mensagens de erro
            setError(error.response?.data?.message || 'Erro ao redefinir a senha. Tente novamente.');
        }
    };

    return (
        <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
            <Row className="w-100">
                <Col md={6} className="mx-auto">
                    <Row>
                        <Col className="d-flex justify-content-center align-items-center m-3 flex-direction-row">
                            <img className="logo-menu" src={menuLogo} alt="logo" style={{ width: '150px' }} />
                        </Col>
                    </Row>
                    <h4 className="text-center">Redefinir Senha</h4>
                    {message && <Alert variant="success" className="mt-3 text-center">{message}</Alert>}
                    {error && <Alert variant="danger" className="mt-3 text-center">{error}</Alert>}
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="formBasicPassword">
                            <Form.Label>Nova Senha</Form.Label>
                            <Form.Control
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Digite sua nova senha"
                                required
                            />
                        </Form.Group>

                        <Form.Group controlId="formBasicConfirmPassword">
                            <Form.Label>Confirme a Nova Senha</Form.Label>
                            <Form.Control
                                type="password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                placeholder="Confirme sua nova senha"
                                required
                            />
                        </Form.Group>
                        <div className="d-flex justify-content-center mt-3">
                            <Button variant="primary" type="submit">
                                Redefinir Senha
                            </Button>
                        </div>
                      
                    </Form>
                </Col>
            </Row>
        </Container>
    );
};

export default ResetPassword;
